import HslTicketInfoView from 'components/park/hslTicket/HslTicketInfoView';
import React from 'react';

type HslTicketScreenProps = {
  mockDateTime?: Date;
};

const ParkAndRideScreen: React.FC<HslTicketScreenProps> = ({
  mockDateTime,
}) => {
  return <HslTicketInfoView mockDateTime={mockDateTime} />;
};

export default ParkAndRideScreen;
